/**
 * Sequential order_number (DB) is shown to customers; UUID id is used for APIs and FKs.
 */

export function formatOrderReference(orderLike) {
  if (orderLike == null) return '—';
  const n = orderLike.order_number;
  if (n != null && n !== '') return String(n);
  const id = orderLike.id;
  if (typeof id === 'string' && id.length >= 8) return id.substring(0, 8).toUpperCase();
  return String(id || '—');
}

/** Parse /order-confirmation/:param — 1..6 digits = order_number, else UUID. */
export function orderConfirmationQueryFromParam(param) {
  const s = String(param ?? '').trim();
  if (!s) return null;
  if (/^\d{1,6}$/.test(s)) {
    return { column: 'order_number', value: parseInt(s, 10) };
  }
  return { column: 'id', value: s };
}

export function orderConfirmationPath(orderLike) {
  if (!orderLike) return '/order-confirmation';
  const n = orderLike.order_number;
  if (n != null) return `/order-confirmation/${n}`;
  if (orderLike.id) return `/order-confirmation/${orderLike.id}`;
  return '/order-confirmation';
}
